/* Layout */
import Layout from '../../views/layout/Layout.vue'

const PromotionCodeList = () => import(/* webpackChunkName: "promo-code-list" */ '@/views/promo-code/list')
const PromotionCodeDetail = () => import(/* webpackChunkName: "promo-code-detail" */ '@/views/promo-code/detail')

export default [
  {
    path: '/promo-code',
    component: Layout,
    redirect: '/promo-code/list',
    name: 'PromotionCode',
    alwaysShow: true,
    meta: {
      title: 'promotionCode',
      icon: 'tags',
    },
    children: [
      {
        path: 'create',
        component: PromotionCodeDetail,
        name: 'PromotionCodeCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'promotionCode',
        },
      },
      {
        path: 'list',
        component: PromotionCodeList,
        name: 'PromotionCodeList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'promotionCode',
        },
        props: true,
      },
      {
        path: 'edit/:id',
        component: PromotionCodeDetail,
        name: 'PromotionCodeDetail',
        meta: {
          title: 'edit',
          icon: 'edit',
          accessibleName: 'promotionCode',
        },
        props: true,
        hidden: true,
      },
    ],
  },
]
